import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { USRCLMLIM_INIT_LOADING, USRCLMLIM_INIT_SUCCESS, USRCLMLIM_INIT_FAIL } from '@/store/types'

export const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [USRCLMLIM_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [USRCLMLIM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [USRCLMLIM_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async usrClmLimManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.usrClmLimManagement
    commit(USRCLMLIM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(USRCLMLIM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(USRCLMLIM_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
